import React, { memo } from 'react';
import { Flex } from '@badi/badi-components';

const BookingFooter = ({ children = null }) => {
  return (
    <Flex
      direction="column"
      gutter={1}
      justify="spaceBetween"
      md={{
        justify: 'flexEnd',
        direction: 'row',
        gutter: 2,
        alignItems: 'center',
      }}
    >
      <Flex
        direction={'column'}
        reverse={true}
        gutter={1}
        md={{
          justify: 'flexEnd',
          direction: 'row',
          gutter: 2,
          alignItems: 'center',
          reverse: false,
        }}
      >
        {children}
      </Flex>
    </Flex>
  );
};

export default memo(BookingFooter);
